<template>
	<div v-if="items.length" class="pd-toc">
		<div class="pd-toc__head">
			<svg viewBox="0 0 36 36" width="22" height="22" aria-hidden="true" class="pd-toc__ring">
				<circle cx="18" cy="18" r="15.9" pathLength="100" />
				<circle cx="18" cy="18" r="15.9" pathLength="100" class="pd-toc__ring-value" :style="{ strokeDasharray: `${Math.round(progress * 100)} 100` }" />
			</svg>
			<p>{{ label }}</p>
		</div>
		<nav :aria-label="label">
			<a
				v-for="item in items"
				:key="item.id"
				:href="`#${item.id}`"
				:class="['pd-toc__item', `is-level-${item.level}`, { 'is-active': item.id === active }]"
			>{{ item.text }}</a>
		</nav>
		<a class="pd-toc__top" href="#ps-main" @click.prevent="toTop">{{ topLabel }} ↑</a>
	</div>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
	active: { type: String, default: "" },
	progress: { type: Number, default: 0 },
	label: { type: String, default: "On this page" },
	topLabel: { type: String, default: "Back to top" },
});
function toTop() {
	window.scrollTo({ top: 0, behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" });
}
</script>
